

export default class Tile {
	constructor(data, id = 0) {
		
		this.type = data.pathType;
		this.arr = data.openings
		this.path = data.path;
		this.path2 = data.path2 || null;
		this.id = id;
		this.state = 'ready';
		this.filled = false;
		this.filled2 = false;
		this.out = this.arr[1];
		this.flowDirection = 'normal'
		this.flowDirection2 = 'normal'
	}


	checkStartFlow(comingFrom) {
		let match = (comingFrom + 2) % 4;
		//No pipe input that matches, no flow.
		return this.type == 'start' || this.arr.includes(match);
	}

	startFlow(comingFrom = null) {
		let sideIn = (comingFrom + 2) % 4;

		switch (this.type) {
			case 'start':
			case 'end':
				document.dispatchEvent(new CustomEvent("score", { detail: 50 }));
				this.filled = true;
				break
			case 'cross':
				this.out = comingFrom
				document.dispatchEvent(new CustomEvent("score", { detail: 50 }));
				switch (sideIn) {
					case 2:
						this.flowDirection = 'reverse'
					case 0:
						this.filled = true
						break
					case 3:
						this.flowDirection2 = 'reverse'
					case 1:
						this.filled2 = true
						break;
				}
				if (this.filled && this.filled2){
					document.dispatchEvent(new CustomEvent("score", { detail: 100 }));
				}
				break
			default:
				document.dispatchEvent(new CustomEvent("score", { detail: 50 }));
				this.filled = true;
				if (sideIn == Math.max(...this.arr)) {
					this.flowDirection = 'reverse'
					this.out = this.arr[0]
				}
				break;
		}
	}


	get locked() {
		return this.filled || this.filled2 || this.type == 'start' || this.type == 'end' || this.state == 'destroy'
	}
}

